"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _close = _interopRequireDefault(require("../../assets/icons/close.svg"));

var _closeInvert = _interopRequireDefault(require("../../assets/icons/close-invert.svg"));

var _bs = require("react-icons/bs");

var _constants = require("./constants");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-notification-container {\n  font-family: \"OpenSansRegular\";\n  box-sizing: border-box;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .bds-notification-container.bds-notification-container-in-place {\n    z-index: 0; }\n\n.bds-notification-container-in-place > .bds-notification {\n  border-radius: 0.375rem; }\n\n.bds-notification {\n  background-color: #067fdb;\n  padding-right: 1rem;\n  display: flex;\n  align-items: center; }\n\n.bds-notification:hover {\n  cursor: pointer; }\n\n.bds-notification-title {\n  vertical-align: middle;\n  display: flex;\n  font-size: 0.875rem;\n  margin-top: 0.4375rem;\n  line-height: 1.1875rem;\n  margin-bottom: 0.5rem; }\n\n.bds-notification-title a {\n  color: inherit; }\n\n.bds-notification-image {\n  display: flex;\n  margin-left: 1rem;\n  margin-right: 0.5rem; }\n  .bds-notification-image .bds-notification-icon {\n    vertical-align: middle;\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem; }\n\n.bds-notification-error-icon-color {\n  color: #ffffff; }\n\n.bds-notification-warning-icon-color {\n  color: #393939; }\n\n.bds-notification-close-button {\n  vertical-align: middle;\n  display: inline-block;\n  cursor: pointer;\n  margin-left: 0.5rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  width: 1.5rem;\n  height: 1.5rem; }\n\n.bds-notification-success {\n  background-color: #24a148;\n  color: #ffffff; }\n\n.bds-notification-error {\n  background-color: #e15c5c;\n  color: #ffffff; }\n\n.bds-notification-general {\n  background-color: #067fdb;\n  color: #ffffff; }\n\n.bds-notification-warning {\n  background-color: #f1c21b;\n  color: #161616; }\n";
  var fileName = "compone_notification";
  var element = document.querySelector("style[data-sass-component='compone_notification']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Notification = function Notification(_ref) {
  var _errorIconClasses, _warningIconClasses, _containerClasses;

  var title = _ref.title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _constants.defaultType : _ref$type,
      duration = _ref.duration,
      onClose = _ref.onClose,
      open = _ref.open,
      _ref$inPlace = _ref.inPlace,
      inPlace = _ref$inPlace === void 0 ? false : _ref$inPlace;
  var timeoutID = null;
  (0, _react.useEffect)(function () {
    if (open) {
      timeoutID = setTimeout(function () {
        onClose && onClose();
      }, duration || _constants.autoHideDuration);
    }
  }, [open]);
  var errorIconClasses = (_errorIconClasses = {}, _defineProperty(_errorIconClasses, _constants.classes.icon, true), _defineProperty(_errorIconClasses, _constants.classes.errorIconColor, true), _errorIconClasses);
  var warningIconClasses = (_warningIconClasses = {}, _defineProperty(_warningIconClasses, _constants.classes.icon, true), _defineProperty(_warningIconClasses, _constants.classes.warningIconColor, true), _warningIconClasses);
  var iconType = {
    error: /*#__PURE__*/_react.default.createElement(_bs.BsExclamationCircle, {
      className: (0, _classnames.default)(_objectSpread({}, errorIconClasses))
    }),
    success: null,
    general: null,
    warning: /*#__PURE__*/_react.default.createElement(_bs.BsExclamationTriangle, {
      className: (0, _classnames.default)(_objectSpread({}, warningIconClasses))
    })
  };
  var containerClasses = (_containerClasses = {}, _defineProperty(_containerClasses, _constants.classes.container, true), _defineProperty(_containerClasses, _constants.classes.inPlaceNotification, inPlace), _containerClasses);
  return open && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, containerClasses))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_constants.classes.notification, " ").concat(_constants.typeToClass[type])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.image
  }, iconType[type]), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.title
  }, title), onClose && /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.closeButton,
    src: type == _constants.warningType ? _close.default : _closeInvert.default,
    alt: type,
    onClick: function onClick() {
      onClose && onClose();
      clearTimeout(timeoutID);
    }
  })));
};

Notification.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  type: _propTypes.default.oneOf(['general', 'success', 'error', 'warning']),
  duration: _propTypes.default.number,
  onClose: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired
};
var _default = Notification;
exports.default = _default;